import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Configuration } from 'src/features/configuration/Configuration';
import { PageLayout } from 'src/layouts/PageLayout';

export function ConfigurationDefaultPage(): ReactElement {
  const { t } = useTranslation('configuration');

  return (
    <PageLayout title={t('configuration')}>
      <Configuration />
    </PageLayout>
  );
}
